import React from 'react';

export default ({ buddyName }) => (
  <div className="acceptedByBuddy">
    <div>{buddyName} has accepted you as a Buddy!</div>
    <div>Click Become Buddy or Decline Buddy.</div>
  </div>
);
